module.exports = __webpack_public_path__ + "img/excel-item.d440a978.svg";